export class Metadata {
    TotalPages: number;
    CurrentPage: number;
    TotalItems: number;
    Count: number;
}
